import React, { Component } from "react";
import { Collapse, Menu, notification, Icon, Modal } from "antd";
import { Link, withRouter } from "react-router-dom";
import axios from "axios";
import screenfull from "screenfull";

import { GlobalContext } from "../../../app/providers/GlobalState";

import TituloModulo from "./TituloModulo";
import Tarefa from "./Tarefa";
import ModalLoading from "../../../shared/components/Modals/ModalLoading";

const confirm = Modal.confirm;
const Panel = Collapse.Panel;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const accessToken = "1f5b9e8481d9c3b11601cc869681281b";

const headerPost = {
    Accept: "application/vnd.vimeo.*+json;version=3.4",
    Authorization: `bearer ${accessToken}`,
    "Content-Type": "application/json"
};

class Modulo extends Component {
    static contextType = GlobalContext;

    state = {
        moduloid: 0,
        tituloModulo: "",
        ordemModulo: "",
        drawerModuloVisible: false,
        precedencia_nome: "",
        precedencia_concluida: false,
        tarefas: [],
        loading: false,
        //COLLAPSE
        aberto: false,
        collapsed: [],
        //PERMISSOES
        curso_iniciado: false,
        //INSCRICAO
        inscrito: false,
        //COPIAR
        visibleCopiar: false,
        //FULLSCREEN
        fullscreen: false
    };

    //CHAMADA ANTES DO RENDER
    componentDidMount() {
        if (this.props.index === this.props.modulo_aberto)
            this.setState({
                aberto: true
            });

        localStorage.setItem("player_back_url", this.props.match.url);
    }

    componentDidUpdate(prevState) {
        const existemDiferencas = this.arraysDeObjetosDiferentes(this.props.modulo.modulo_Aula, prevState.modulo.modulo_Aula);

        if (existemDiferencas) {
            this.setState({
                tarefas: [...this.props.modulo.modulo_Aula]
            });
        }
    }

    onClink = aulaId => {
        localStorage.setItem("modulo_aberto", this.props.index);
        localStorage.setItem("codigo_aula", aulaId);
    };

    onChangeCollapse = collapsed => {
        if (collapsed.length > this.state.collapsed.length) {
            this.setState(
                {
                    collapsed
                },
                () => {
                    this.carregarTarefas(collapsed);
                }
            );
        } else
            this.setState({
                collapsed
            });
    };

    carregarTarefas = collapsed => {
        this.setState({
            loading: true
        });
        axios({
            method: "get",
            url: "/api/gerir-curso-modulo/carregar-tarefas",
            params: {
                atividadeId: collapsed[collapsed.length - 1]
            }
        })
            .then(response => {
                this.setState({
                    tarefas: response.data,
                    loading: false
                });
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login",
                        loading: false
                    });
            });
    };

    objetosSaoIguais(a, b) {
        return JSON.stringify(a) === JSON.stringify(b);
    }

    arraysDeObjetosDiferentes(arr1, arr2) {
        if (arr1.length !== arr2.length) return true;

        return arr1.some((item, i) => !this.objetosSaoIguais(item, arr2[i]));
    }

    //MONTA AS OPÇÕES DE MENU POR AULA DE PRIMEIRO NIVEL
    montarMenuAula = (moduloid, competencias, aula) => {
        const acesso = this.context.acessos?.find(x => x.func === 18);
        const aulaId = aula.id;
        const tipo = aula.tipo_Recurso.id;
        const ativo = aula.ativo;
        const recurso = aula.recurso;

        return (
            <Menu>
                {acesso?.update && (
                    <Menu.Item key={"modulo_" + moduloid + "_copiar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                this.props.copiarTarefa(aulaId);
                            }}
                        >
                            Copiar tarefa
                        </Link>
                    </Menu.Item>
                )}
                {tipo === 1 && acesso?.update && (
                    <Menu.Item key={moduloid + "_" + aulaId + "_editar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                this.props.carregarAulaVideo(moduloid, aulaId, false);
                            }}
                        >
                            Editar tarefa
                        </Link>
                    </Menu.Item>
                )}
                {tipo === 2 && acesso?.update && (
                    <Menu.Item key={moduloid + "_" + aulaId + "_editar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                this.props.carregarAulaAudio(moduloid, aulaId, false);
                            }}
                        >
                            Editar tarefa
                        </Link>
                    </Menu.Item>
                )}
                {tipo === 3 && acesso?.update && (
                    <Menu.Item key={moduloid + "_" + aulaId + "_editar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                this.props.carregarAulaHtml(moduloid, aulaId, false);
                            }}
                        >
                            Editar tarefa
                        </Link>
                    </Menu.Item>
                )}
                {tipo === 4 && acesso?.update && (
                    <Menu.Item key={moduloid + "_" + aulaId + "_editar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                this.props.carregarAulaPdf(moduloid, aulaId, false);
                            }}
                        >
                            Editar tarefa
                        </Link>
                    </Menu.Item>
                )}
                {(tipo === 5 || tipo === 6 || tipo === 15) && acesso?.update && (
                    <Menu.Item key={moduloid + "_" + aulaId + "_editar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                this.props.carregarAulaQuestionario(moduloid, competencias, aulaId, false);
                            }}
                        >
                            Editar tarefa
                        </Link>
                    </Menu.Item>
                )}
                {tipo === 7 && acesso?.update && (
                    <Menu.Item key={moduloid + "_" + aulaId + "_editar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                this.props.carregarAulaDownload(moduloid, aulaId, false);
                            }}
                        >
                            Editar tarefa
                        </Link>
                    </Menu.Item>
                )}
                {tipo === 8 && acesso?.update && (
                    <Menu.Item key={moduloid + "_" + aulaId + "_editar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                this.props.carregarAulaTrabalho(moduloid, aulaId, false);
                            }}
                        >
                            Editar tarefa
                        </Link>
                    </Menu.Item>
                )}
                {tipo > 8 && tipo !== 15 && tipo !== 13 && acesso?.update && (
                    <Menu.Item key={moduloid + "_" + aulaId + "_editar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                this.props.carregarAula(moduloid, aulaId, false);
                            }}
                        >
                            Editar tarefa
                        </Link>
                    </Menu.Item>
                )}
                {tipo === 13 && acesso?.update && (
                    <Menu.Item key={moduloid + "_" + aulaId + "_editar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                this.props.carregarAulaPasta(moduloid, aulaId, false);
                            }}
                        >
                            Editar tarefa
                        </Link>
                    </Menu.Item>
                )}
                {tipo === 1 && acesso?.delete && (
                    <Menu.Item key={moduloid + "_" + aulaId + "_excluir"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                this.excluirVideoVimeo(aulaId, recurso);
                            }}
                        >
                            Excluir
                        </Link>
                    </Menu.Item>
                )}
                {tipo > 1 && acesso?.delete && (
                    <Menu.Item key={moduloid + "_" + aulaId + "_excluir"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                this.excluirAula(aulaId);
                            }}
                        >
                            Excluir
                        </Link>
                    </Menu.Item>
                )}
                {acesso?.update && (
                    <Menu.Item key={moduloid + "_" + aulaId + "_ativar"}>
                        <Link
                            to="#"
                            onClick={event => {
                                event.stopPropagation();
                                this.ativarAula(aulaId, ativo);
                            }}
                        >
                            {ativo ? "Ocultar" : "Mostrar"}
                        </Link>
                    </Menu.Item>
                )}
            </Menu>
        );
    };

    colarTarefa = (aulaId, moduloId, aulaPaiId) => {
        confirm({
            title: "Pretende copiar a tarefa?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                this.setState(
                    {
                        visibleCopiar: true,
                        textoModal: "copiar"
                    },
                    () => {
                        axios({
                            method: "post",
                            url: "/api/curso-aula/copiar-aula",
                            params: {
                                id_modulo_aula: aulaId,
                                id_curso_modulo: moduloId,
                                id_aula_pai: aulaPaiId
                            }
                        })
                            .then(() => {
                                this.props.listarModulo(moduloId);

                                this.setState({
                                    visibleCopiar: false
                                });

                                this.context.atualizarState({
                                    id_copia_tarefa: 0
                                });

                                this.context.atualizarEventosHoje();
                            })
                            .catch(error => {
                                openNotificationWithIcon("error", "Erro", error.response.data);
                                this.setState({
                                    visibleCopiar: false
                                });
                            });
                    }
                );
            }
        });
    };

    //EXCLUI A AULA
    excluirAula = aulaId => {
        confirm({
            title: "Pretende excluir este conteúdo?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "delete",
                    url: "/api/turma-conteudos/excluir-tarefa",
                    params: {
                        aulaId
                    }
                })
                    .then(() => {
                        const aula = this.state.tarefas.find(x => x.id === aulaId);
                        const tarefasAtualizadas = this.state.tarefas.filter(x => x.id !== aulaId);

                        this.setState({
                            tarefas: tarefasAtualizadas
                        });

                        const tiposQueAtualizam = [6, 8, 11];
                        if (tiposQueAtualizam.includes(aula?.tipo_Recurso?.id)) {
                            this.context.atualizarEventosHoje();
                        }

                        openNotificationWithIcon("success", "Sucesso", "Conteúdo excluido!");
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response.data);
                    });
            }
        });
    };

    //EXCLUI A AULA
    excluirVideoVimeo = (aulaid, videoId) => {
        confirm({
            title: "Pretende excluir esta tarefa?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "get",
                    url: "/api/curso/validar-excluir-vimeo",
                    params: {
                        videoId
                    }
                })
                    .then(response => {
                        if (response.data) this.excluirAula(aulaid);
                        else
                            axios({
                                method: "delete",
                                url: `https://api.vimeo.com/videos/${videoId}`,
                                headers: headerPost
                            }).then(() => {
                                this.excluirAula(aulaid);
                            });
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível excluir a tarefa!");
                    });
            }
        });
    };

    //ATIVAR/INATIVAR A AULA
    ativarAula = (aulaId, ativo) => {
        confirm({
            title: ativo ? "Pretende ocultar esta tarefa?" : "Pretende mostrar esta tarefa?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/turma-conteudos/ativar-tarefa",
                    params: {
                        aulaId
                    }
                })
                    .then(() => {
                        var _tarefas = [...this.state.tarefas];
                        var tarefaIndex = _tarefas.findIndex(x => x.id === aulaId);

                        _tarefas[tarefaIndex].ativo = !ativo;

                        this.setState({
                            tarefas: _tarefas
                        });

                        if (ativo) openNotificationWithIcon("success", "Sucesso", "Tarefa ocultada!");
                    })
                    .catch(() => {
                        openNotificationWithIcon(
                            "error",
                            "Erro",
                            ativo ? "Não foi possível ocultar a tarefa!" : "Não foi possível mostrar a tarefa!"
                        );
                    });
            }
        });
    };

    render() {
        const {
            loading,
            tarefas,
            //COLLAPSE
            collapsed,
            //COPIAR
            visibleCopiar,
            //FULLSCREEN
            fullscreen
        } = this.state;

        const { index, turma, modulo, disabled, player, botoesVisiveis } = this.props;

        const montaAula = aula => {
            var inicioUrl = `/turma-player/${turma.replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}/${aula.nome
                .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                .toLowerCase()}-${Math.floor(100000 + Math.random() * 900000)}`;

            return (
                <Tarefa
                    aula={aula}
                    inicioUrl={inicioUrl}
                    botoesVisiveis={botoesVisiveis}
                    modulo={modulo}
                    montarMenuAula={this.montarMenuAula}
                    onClink={this.onClink}
                />
            );
        };

        return (
            <>
                <Collapse activeKey={collapsed} bordered={false} onChange={this.onChangeCollapse} key={index}>
                    <Panel
                        header={
                            <TituloModulo
                                modulo={modulo}
                                botoesVisiveis={botoesVisiveis}
                                onOpenDrawerAula={this.props.onOpenDrawerAula}
                                colarTarefa={this.colarTarefa}
                                carregarModulo={this.props.carregarModulo}
                                excluirModulo={this.props.excluirModulo}
                                ativarModulo={this.props.ativarModulo}
                            />
                        }
                        key={modulo.id}
                        className={!modulo.ativo ? "modulo ativo" : "modulo"}
                        disabled={disabled}
                    >
                        <ul>
                            {loading && (
                                <div className="loading-data min-loading-data">
                                    <div className="loading" />
                                </div>
                            )}
                            {tarefas.map((aula, index) => (
                                <li key={index}>
                                    <div className={aula.ativo ? "nivel1" : "nivel1 inativo"}>{montaAula(aula)}</div>
                                </li>
                            ))}
                        </ul>
                    </Panel>
                </Collapse>
                <ModalLoading visible={visibleCopiar} text="A copiar..." />
            </>
        );
    }
}

export default withRouter(Modulo);
